import { useSyncExternalStore } from "react";
import {
  getNowPlayingPronunciation,
  subscribeNowPlayingPronunciation,
} from "#shared-pronunciation-player";

/**
 * Whether the shared player is sounding this tone-number pinyin right now — whether a press, a
 * reveal's auto-play or a sequence started it. Only the readings whose state flips re-render.
 */
export function useIsPronunciationPlaying(pinyin: string): boolean {
  return useSyncExternalStore(
    subscribeNowPlayingPronunciation,
    () => getNowPlayingPronunciation() === pinyin,
    () => false,
  );
}
